export const RegistrationError = (props) => {
  return (
    <div id="ess_error">
      {props.inError === true ? (
        <div className="hc-clr-error">{props.message}</div>
      ) : null}
    </div>
  )
}
